import MicroModal from "micromodal";

const modalHTML = `
  <!-- [1] -->
  <div id="disneyIceModal" class="disney-ice-modal" aria-hidden="true">

    <!-- [2] -->
    <div tabindex="-1" class="modal__overlay" data-micromodal-close>

      <!-- [3] -->
      <div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="modal-1-title" >


        <header>
          <h2 id="modal-1-title" class="modal__title">
            Please Note
          </h2>
        </header>

        <div id="modal-1-content" class="modal__content">
          <p>By purchasing or using a ticket to attend the event, you agree to the Event Organizer's         
          <a href="http://DisneyOnIce.com/ticket-terms-and-conditions" target="_blank">Ticket Terms and Conditions.</a>
          </p>
          
          <br>
          <div class="modal__close button" tabindex="1" role="button" data-micromodal-close>I Agree</div>
        </div>

      </div>
    </div>
  </div>
`;

export default function disneyIceModal() {
  const ss = sessionStorage.getItem("disney-ice-message");

  if (ss !== "shown") {
    $("#body").prepend(modalHTML);
    MicroModal.show("disneyIceModal");
    sessionStorage.setItem("disney-ice-message", "shown");
  }
}
